import json2csv from 'json2csv';

/**
 * Generates and downloads a csv file from an array of JSON objects.
 * @param  {array} data       An array of JSON objects containing the data.
 * @param  {array} fields     An array of the fields in the JSON objects to export.
 * @param  {array} fieldNames An array of the field names (headers). Same length as fields.
 * @param  {string} filename  The filename to download it under.
 * @return {void}
 */
const downloadCSV = (data, fields, fieldNames, filename) => {
  json2csv({
    data: data,
    fields: fields,
    fieldNames: fieldNames,
    newLine: '\r\n',
  }, (err, csv) => {
    if (err) {
      console.log(err);
    }
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    if (window.navigator.msSaveOrOpenBlob) {
      link.onclick = () => {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      };
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

export default downloadCSV;
